module.exports = __webpack_public_path__ + "img/slide2-9.24eac165.png";